import { useI18n } from '../../../../../i18n';
import useLabelingStore from "../store/useDetectionStore"
import Label from "../../../../../components/Atoms/Label.jsx";

const DetectionLeft = () => {
    const { images, currentImageIndex, setCurrentImageIndex, handleImageUpload, setDragOver, dragOver, masterImageId } = useLabelingStore();
    const { t } = useI18n();

    const handleImageUpload_callback = (e) => {
        const files = Array.from(e.target.files);
        handleImageUpload(files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = () => {
        setDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const files = Array.from(e.dataTransfer.files);
        if (files.length > 0) {
            handleImageUpload(files);
        }
    };

    const hasLabels = (img) => ((img?.annotations?.length ?? 0) > 0 || (img?.polygons?.length ?? 0) > 0);

    return (
        <div className="detection-left-panel">
            <div
                className={`detection-upload-zone ${dragOver ? 'drag-over' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <Label
                    htmlFor="unstructured-file-upload"
                    tooltipText="Upload raw images"
                    className="btn-primary upload-button"
                    children="Upload Images"
                />
                <input
                    id="unstructured-file-upload"
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageUpload_callback}
                    style={{ display: 'none' }}
                />
                <p className="detection-upload-hint">or drag and drop <b className="text-primary">images</b> here</p>
            </div>

            <div className="detection-image-list-section">
                <h6 className="detection-image-list-header">Images ({images?.length ?? 0})</h6>
                <ul className="detection-image-list-ul">
                    {images?.length === 0 ? (
                        <li className="detection-image-list-empty">No images yet</li>
                    ) : (
                        images?.map((img, i) => {
                            const isSelected = i === currentImageIndex;
                            const labeled = hasLabels(img);
                            return (
                                <li
                                    key={i}
                                    className={`detection-image-item ${isSelected ? 'detection-image-item--selected' : ''}`}
                                    onClick={() => setCurrentImageIndex(i)}
                                >
                                    <span className="detection-image-item__name" title={img?.fileName}>
                                        {img?.fileName}
                                    </span>
                                    {masterImageId && img?.id === masterImageId && (
                                        <span
                                            className="detection-image-item__master"
                                            title={t('aiLabel.master.marker')}
                                        >
                                            <i className="fa fa-thumbtack" aria-hidden="true"></i> {t('aiLabel.master.badge')}
                                        </span>
                                    )}
                                    {labeled && (
                                        <span className="detection-image-item__meta">
                                            {img?.annotations?.length ?? 0} boxes, {img?.polygons?.length ?? 0} polygons
                                        </span>
                                    )}
                                </li>
                            );
                        })
                    )}
                </ul>
            </div>
        </div>
    );
};

export default DetectionLeft;
